module.exports = __webpack_public_path__ + "media/images/getting-started-docs-373b4bcb542d923245814bcca7d99ace.png";